import React from 'react';
import { Field } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FormTextField from '../../../components/Form/FormTextField/FormTextField';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { validateRateField } from '../helpers/validationHelpers';

const RateOverridesSection = () => {
  const theme = useTheme();

  const sectionHeaderStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  };

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  return (
    <>
      <Typography sx={sectionHeaderStyle}>
        {LanguageConverterV2('contract.create.rateOverrides')}
      </Typography>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.rateOverridesQuestion')}
      </Typography>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.payRatesQuestion')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Field name="payRate" validate={validateRateField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.payRate')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field name="otPayRate" validate={validateRateField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.otPayRate')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
              />
            )}
          </Field>
        </Grid>
      </Grid>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.billRatesQuestion')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Field name="billRate" validate={validateRateField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.billRate')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field name="otBillRate" validate={validateRateField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.otBillRate')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </>
  );
};

export default RateOverridesSection;
